<template>
    <div class="animated fadeIn">
        <b-container fluid class="p-0">
            <b-col align="right" v-if="showEvaluateButton()">
                <b-button href="#" @click="changeAside(target)" variant="outline-primary" size="sm">
                    {{ $t('profile.targetsTable.evaluate') }}
                </b-button>
            </b-col>
            <div v-for="evaluation in evaluations" v-bind:key="evaluation.id">
                <b-row class="pt-4 ml-2">
                    <avatar
                        :size="35"
                        :src="evaluation.user.picture"
                        :username="evaluation.user.name"
                        slot="aside"
                        class="d-down-none mt-2"
                    />

                    <b-col sm="2" class="mt-1">
                        <p class="mb-0 text-muted text-small-sm-down text-justify">
                            <strong>
                                {{ evaluation.user.name }}
                            </strong>
                        </p>
                        <small class="text-muted">
                            <i class="icon-calendar mr-1"></i>
                            {{ evaluation.updated_at | formatDate }}
                        </small>
                    </b-col>

                    <b-col cols="2" class="mt-1">
                        <strong>
                            <p class="text-right m-0">
                                {{ $t(`profile.targetsTable.${evaluationsType}`) }}
                            </p>
                        </strong>

                        <p class="text-muted text-right m-0">{{ evaluation.weightedEvaluation }}%</p>

                        <div>
                            <progress-bar :value="100" :color="evaluation.rangeColor" />
                        </div>
                    </b-col>

                    <b-col class="mx-4">
                        <b-card class="overflow-auto" style="max-height: 11rem">
                            <b-card-text v-if="canSeeComment()">
                                <p class="text-muted m-0">
                                    {{ evaluation.comments || $t('profile.targetsTable.evaluationWithoutComment') }}
                                </p>
                            </b-card-text>
                            <b-card-text v-else>
                                <p class="text-muted m-0">
                                    {{ $t('profile.targetsTable.userWithoutPermission') }}
                                </p>
                            </b-card-text>
                        </b-card>
                    </b-col>

                    <b-col cols="2" class="mt-3" v-if="canEdit(evaluation.user.id)">
                        <b-button href="#" @click="changeAside(target, evaluation)" variant="outline-primary" size="sm">
                            {{ $t('edit') }}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>
</template>

<script>
import avatar from 'vue-avatar'
import Aside from '@/shared/aside'
import { TargetEvaluationAside } from '@/views/evaluation'
import ProgressBar from '@/views/components/progress-bar/ProgressBar'

export default {
    name: 'TargetEvaluationContent',
    props: ['target', 'currentUserId', 'currentEventPermissions', 'isAdmin', 'evaluations', 'evaluationsType'],
    components: {
        avatar,
        ProgressBar,
    },
    data() {
        return {
            evaluationColor: null,
        }
    },
    methods: {
        changeAside(target, evaluation) {
            Aside.open(
                TargetEvaluationAside, //componente para renderizar
                { target, type: evaluation.type, evaluation: evaluation }, //props para passar para o componente
                () => this.$emit('updated')
            )
        },
        showEvaluateButton() {
            const evaluatorIds = this.evaluations.map((el) => el.user_id)

            return !evaluatorIds.includes(this.currentUserId) && this.canEvaluate()
        },
        canEvaluate() {
            switch (this.evaluationsType) {
                case 'selfEvaluate':
                    return false
                case 'managerEvaluate':
                    return this.canDoManagerEvaluation()
                case 'committeeEvaluation':
                    return this.canDoCommitteeEvaluation()
            }
        },
        canEdit(userId) {
            if (this.currentUserId == userId) {
                return this.getEventPermission()
            }
            return false
        },
        getEventPermission() {
            switch (this.evaluationsType) {
                case 'selfEvaluate':
                    return this.currentEventPermissions[this.target.level].allow_self_evaluation
                case 'managerEvaluate':
                    return this.currentEventPermissions[this.target.level].allow_manager_evaluation
                case 'committeeEvaluation':
                    return this.currentEventPermissions[this.target.level].allow_committee_to_evaluate_goals
            }
        },
        canSeeComment() {
            if (
                this.target.committeesUsers.includes(this.currentUserId) ||
                this.evaluationsType == 'selfEvaluate' ||
                this.isAdmin
            ) {
                return true
            }

            if (this.evaluationsType == 'managerEvaluate') {
                return this.currentEventPermissions[this.target.level].allow_manager_evaluation
            }

            return false
        },
        canDoManagerEvaluation() {
            const isManagerOfTargetOwner = this.currentUserId == this.target.owner.manager_id
            const managerEvaluationPermission = this.currentEventPermissions[this.target.level].allow_manager_evaluation

            return isManagerOfTargetOwner && managerEvaluationPermission
        },
        canDoCommitteeEvaluation() {
            const committeeEvaluationPermission =
                this.currentEventPermissions[this.target.level].allow_view_committee_evaluation
            return this.target.committeesUsers.includes(this.currentUserId) && committeeEvaluationPermission
        },
    },
}
</script>
